module.exports = __webpack_public_path__ + "static/media/sand-clock.0d95ec42.svg";